import { render, staticRenderFns } from "./BanButton.vue?vue&type=template&id=0c915794"
import script from "./BanButton.vue?vue&type=script&lang=ts"
export * from "./BanButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports